export default{banner:"w_M",contentContainer:"w_N",content:"w_O",error:"w_P",info:"w_Q",success:"w_R",warning:"w_S"};
